const CustomerPortalUsersList = () =>
  import('../screens/CustomerPortalUsers/List/CustomerPortalUsersList.vue');

export default [
  {
    component: CustomerPortalUsersList,
    meta: {
      activeSidebarItemId: 'customer-portal-users',
      authority: 'merchant_users:view',
      pageTitle: 'Merchant Users',
    },
    name: 'customer-portal-users',
    path: '/customer-portal-users',
  },
];
